(function(root) {
	"use strict";

	function parseResponse(response) {
		if (!response) {
			return null;
		}
		if (typeof response === "string") {
			try {
				return JSON.parse(response);
			} catch (error) {
				return null;
			}
		}
		return response;
	}

	function newTraceId() {
		return "evtimp_" + Date.now().toString(36) + "_" + Math.random().toString(36).slice(2, 8);
	}

	function create(options) {
		options = options || {};
		var storage = options.storage || root.localStorage;
		var activeStorage = options.activeStorage || root.sessionStorage || storage;
		var storagePrefix = "wf_event_import_job_" + options.movementId;
		var activeKey = storagePrefix + "_active";
		var ajax = options.ajax || (root.jQuery && root.jQuery.ajax);
		var schedule = options.schedule || root.setTimeout;
		var cancel = options.cancel || root.clearTimeout;
		var timer = null;

		function jobKey(traceId) {
			return storagePrefix + "_" + traceId;
		}

		function readValue(target, key) {
			try {
				var value = target && target.getItem(key);
				return value ? JSON.parse(value) : null;
			} catch (error) {
				return null;
			}
		}

		function readJob(traceId) {
			if (!traceId) {
				return null;
			}
			return readValue(storage, jobKey(traceId));
		}

		function readActiveTraceId() {
			try {
				return activeStorage && activeStorage.getItem(activeKey);
			} catch (error) {
				return null;
			}
		}

		function read() {
			return readJob(readActiveTraceId());
		}

		function ownsActiveJob(traceId) {
			return readActiveTraceId() === traceId;
		}

		function write(job) {
			if (!job || !job.trace_id) {
				return;
			}
			try {
				if (storage) {
					storage.setItem(jobKey(job.trace_id), JSON.stringify(job));
				}
				if (activeStorage) {
					activeStorage.setItem(activeKey, job.trace_id);
				}
			} catch (error) {}
		}

		function clear(traceId) {
			var activeTraceId = readActiveTraceId();
			try {
				if (storage) {
					storage.removeItem(jobKey(traceId || activeTraceId));
				}
				if (activeStorage && activeTraceId && activeTraceId === (traceId || activeTraceId)) {
					activeStorage.removeItem(activeKey);
				}
			} catch (error) {}
		}

		function stop() {
			if (timer) {
				cancel(timer);
				timer = null;
			}
		}

		function mounted() {
			return !options.isMounted || options.isMounted();
		}

		function terminal(response, traceId) {
			var isActive = ownsActiveJob(traceId);
			clear(traceId);
			if (isActive) {
				stop();
			}
			if (isActive && options.onTerminal) {
				options.onTerminal(response, traceId);
			}
		}

		function scheduleCallback(traceId, callback) {
			if (!ownsActiveJob(traceId)) {
				return;
			}
			stop();
			timer = schedule(callback, options.pollDelay || 3000);
		}

		function requestStart(traceId) {
			var current = readJob(traceId);
			if (!current || !ownsActiveJob(traceId) || !current.start_data || !mounted()) {
				return;
			}
			request(options.startUrl, current.start_data, traceId, false);
		}

		function retryStart(traceId) {
			// `status not found` is ambiguous: the original HTTP start can still
			// queue a worker. Replaying the same trace and persisted parameters is
			// idempotent on the server, so it is safer than minting a new job.
			scheduleCallback(traceId, function() {
				requestStart(traceId);
			});
		}

		function observe(response, traceId) {
			if (response && (response.status === "completed" || response.status === "failed")) {
				terminal(response, traceId);
				return;
			}
			if (!ownsActiveJob(traceId)) {
				return;
			}
			if (options.onStatus) {
				options.onStatus(response || { status: "running" }, traceId);
			}
			poll(traceId);
		}

		function request(url, data, traceId, isStatusPoll) {
			if (typeof ajax !== "function") {
				terminal({ status: "failed", error: "The import helper is unavailable." }, traceId);
				return;
			}
			ajax({
				url: url,
				method: "POST",
				data: data,
				timeout: 30000
			})
			.done(function(response) {
				var json = parseResponse(response);
				if (json && json.success) {
					observe(json, json.trace_id || traceId);
					return;
				}
				// A nonterminal status response, including "not found", cannot prove
				// the original start failed. Preserve identity and replay that start.
				if (isStatusPoll) {
					retryStart(traceId);
				}
				else {
					poll(traceId);
				}
			})
			.fail(function() {
				if (isStatusPoll) {
					retryStart(traceId);
				}
				else {
					poll(traceId);
				}
			});
		}

		function poll(traceId) {
			if (!traceId || !ownsActiveJob(traceId) || !mounted()) {
				return;
			}
			scheduleCallback(traceId, function() {
				request(options.statusUrl, options.statusData(traceId), traceId, true);
			});
		}

		return {
			start: function(url, buildStartData) {
				var current = read();
				var reusable = current && current.url === url && current.mode === (options.mode || "bulk") && current.trace_id && current.start_data;
				var traceId = reusable ? current.trace_id : newTraceId();
				var startData = reusable ? current.start_data : buildStartData(traceId);
				stop();
				write({ trace_id: traceId, url: url, mode: options.mode || "bulk", start_data: startData });
				if (options.onPending) {
					options.onPending(traceId, url);
				}
				request(options.startUrl, startData, traceId, false);
				return traceId;
			},
			resume: function() {
				var current = read();
				if (!current || !current.trace_id || !current.url || !current.start_data) {
					return null;
				}
				if (options.onResume) {
					options.onResume(current);
				}
				poll(current.trace_id);
				return current;
			},
			stop: stop,
			clear: function() {
				clear(readActiveTraceId());
			},
			read: read
		};
	}

	var api = { create: create };
	if (typeof module !== "undefined" && module.exports) {
		module.exports = api;
	}
	root.WF_Event_Import_Jobs = api;
})(typeof window !== "undefined" ? window : global);
